import { toast } from "sonner";
import { api, ago, errText, fmtPx } from "@/lib/api";

export const STATUS_STYLE = {
  executed: "bg-[rgba(14,203,129,0.12)] text-[#0ecb81]", pending_approval: "bg-[rgba(252,213,53,0.12)] text-[#fcd535]", recommended: "bg-[rgba(59,130,246,0.15)] text-[#3b82f6]",
  rejected_risk: "bg-[rgba(246,70,93,0.12)] text-[#f6465d]", rejected_user: "bg-[#2b3139] text-[#848e9c]", hold: "bg-[#2b3139] text-[#848e9c]", expired: "bg-[#2b3139] text-[#5e6673]",
  execution_failed: "bg-[rgba(246,70,93,0.12)] text-[#f6465d]", approved: "bg-[rgba(14,203,129,0.12)] text-[#0ecb81]",
};

export function SignalsTable({ signals = [], onChange, onSelect, compact }) {
  const act = async (id, action) => {
    try {
      await api.post(`/signals/${id}/${action}`);
      toast[action === "approve" ? "success" : "info"](action === "approve" ? "Signal approved · position opened" : "Signal rejected");
      onChange?.();
    } catch (e) { toast.error(errText(e)); }
  };
  const entryPx = (s) => (s.entry && typeof s.entry === "object" ? s.entry.price : s.entry);
  return (
    <div className="overflow-x-auto" data-testid="ai-signals-table">
      <table className="grid">
        <thead><tr>
          <th>Asset</th><th>Signal</th><th className="num">Conf</th><th>Strategy</th><th className="num">Entry</th><th className="num">Stop</th><th className="num">Target</th>
          {!compact && <th className="num">Risk</th>}{!compact && <th>Reason</th>}<th>Status</th><th>Age</th><th></th>
        </tr></thead>
        <tbody>
          {signals.length === 0 && <tr><td colSpan={12} className="text-center text-[#5e6673] py-6">No signals yet — start the engine or run analysis</td></tr>}
          {signals.map((s) => (
            <tr key={s.id} className="cursor-pointer" onClick={() => onSelect?.(s)} data-testid={`signal-row-${s.id}`}>
              <td className="font-semibold text-white">{s.symbol}</td>
              <td><span className={`pill ${s.action === "BUY" ? "bg-[rgba(14,203,129,0.12)] text-[#0ecb81]" : s.action === "SELL" ? "bg-[rgba(246,70,93,0.12)] text-[#f6465d]" : "bg-[#2b3139] text-[#848e9c]"}`}>{s.action === "BUY" ? "LONG" : s.action === "SELL" ? "SHORT" : "HOLD"}</span></td>
              <td className="num"><span className={s.confidence >= 0.7 ? "text-[#0ecb81]" : s.confidence >= 0.5 ? "text-[#fcd535]" : "text-[#848e9c]"}>{Math.round(s.confidence * 100)}%</span></td>
              <td className="text-[#848e9c]">{s.strategy}{s.llm_used && <span className="ml-1 text-[9px] text-[#fcd535]">AI</span>}</td>
              <td className="num">{fmtPx(entryPx(s))}</td><td className="num text-[#f6465d]">{fmtPx(s.stop_loss)}</td>
              <td className="num text-[#0ecb81]">{(s.take_profit || []).length ? fmtPx(s.take_profit[0]) : "—"}</td>
              {!compact && <td className="num">{s.risk_percent != null ? `${s.risk_percent}%` : "—"}</td>}
              {!compact && <td className="max-w-[260px] truncate text-[#848e9c]" title={(s.reasoning || []).join(" · ")}>{(s.reasoning || [])[0] || (s.risk_violations || [])[0] || "—"}</td>}
              <td><span className={`pill ${STATUS_STYLE[s.status] || STATUS_STYLE.hold}`} data-testid={`signal-status-${s.id}`}>{s.status.replace(/_/g, " ")}</span></td>
              <td className="text-[#5e6673] mono text-[11px]">{ago(s.created_at)}</td>
              <td onClick={(e) => e.stopPropagation()}>
                {(s.status === "pending_approval" || s.status === "recommended") && (
                  <div className="flex gap-1">
                    <button onClick={() => act(s.id, "approve")} className="btn-green rounded px-2 h-6 text-[10px]" data-testid={`ai-signal-execute-btn-${s.id}`}>Execute</button>
                    <button onClick={() => act(s.id, "reject")} className="btn-ghost rounded px-2 h-6 text-[10px]" data-testid={`ai-signal-reject-btn-${s.id}`}>Reject</button>
                  </div>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
